import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateTicketById } from '../../../../../../../app/store/slices/ticket/ticket';

export default function useMarkTicketSaleEnded() {
    const dispatch = useDispatch();
    const [selectedTicketId, setSelectedTicketId] = useState(null);
    const [openSaleEndedDialog, setOpenSaleEndedDialog] = useState(false);

    async function markTicketSaleEnded() {
        try {
            await dispatch(
                updateTicketById({
                    ticketId: selectedTicketId,
                    ticketData: {
                        sale_status: 'sale_ended'
                    }
                })
            ).unwrap();
            setOpenSaleEndedDialog(false);
        } catch (error) {
            console.error('Error marking ticket as sold out:', error);
        }
    }

    function handleOpenSaleEndedDialog(ticketId) {
        setSelectedTicketId(ticketId);
        setOpenSaleEndedDialog(true);
    }

    function handleCloseSaleEndedDialog() {
        setOpenSaleEndedDialog(false);
        setSelectedTicketId(null);
    }

    return {
        openSaleEndedDialog,
        markTicketSaleEnded,
        handleOpenSaleEndedDialog,
        handleCloseSaleEndedDialog
    };
}
